module.exports = __webpack_public_path__ + "img/news-01.59faa129.jpeg";